import React from "react";
import { cn } from "@oxpa/shared/lib/utils";

interface OxpaLogoProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

export function OxpaLogo({ className, ...props }: OxpaLogoProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      className={cn("text-current fill-current", className)}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50 85C69.33 85 85 69.33 85 50C85 30.67 69.33 15 50 15C30.67 15 15 30.67 15 50C15 69.33 30.67 85 50 85ZM50 65C58.2843 65 65 58.2843 65 50C65 41.7157 58.2843 35 50 35C41.7157 35 35 41.7157 35 50C35 58.2843 41.7157 65 50 65Z"
      />
    </svg>
  );
}
